import React from 'react';
import PropTypes from 'prop-types';

import styles from './LinkList.module.scss';

const LinkList = ({ list, onClick }) => (
    <ul className={styles['link-list-component']}>
        {(list || []).map(({ url, name }) => (
            <li key={url}>
                <a onClick={onClick} href={url} title={name}>
                    {name}
                </a>
            </li>
        ))}
    </ul>
);

LinkList.propTypes = {
    onClick: PropTypes.func,
    list: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            url: PropTypes.string,
        }),
    ),
};

export default LinkList;
